
import { Component, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TrackingResumeModel } from 'src/models/trackingResumeModel';
import { CourseResume } from 'src/models/userInfo';
import { ScormService } from 'src/services/scorm.service';

@Component({
    selector: 'app-tracking-console',
    templateUrl: './tracking-console.component.html',
    styleUrls: ['./tracking-console.component.scss'],
    imports: [MatFormFieldModule, MatTableModule, MatSelectModule]
})
export class TrackingConsoleComponent implements OnInit {

  trackingsResumeModel: TrackingResumeModel[] = [];
  courseResume: CourseResume[] = [];

  displayedColumns: string[] = ['courseName', 'isCompleted'];
  dataSource = new MatTableDataSource<CourseResume>();

  constructor(private scormService: ScormService) { }

  ngOnInit(): void {

    this.scormService.getAllTrackings().subscribe(res => {
      console.log(res);
      this.trackingsResumeModel = res;
    });
  }

  onSelectionChange(event: MatSelectChange) {
    this.courseResume = [];
    const selectedValue = event.value;
    var user = this.trackingsResumeModel.find(item => item.ssoId == selectedValue);

    /*   this.scormService.scormPackages.forEach(element => {
        var isCompleted = false;
        if (user?.scormsCompleted.includes(element.scormContentId)) {
          isCompleted = true;
        }
  
        this.courseResume.push(new CourseResume(element.courseName, isCompleted));
      }); */

    this.dataSource.data = this.courseResume;

    console.log(this.courseResume);
  }

}
